import { render, staticRenderFns } from "./Layout.vue?vue&type=template&id=04a1fd48&scoped=true"
import script from "./Layout.vue?vue&type=script&lang=js"
export * from "./Layout.vue?vue&type=script&lang=js"
import style0 from "./Layout.vue?vue&type=style&index=0&id=04a1fd48&prod&lang=scss&scoped=true"
import style1 from "./Layout.vue?vue&type=style&index=1&id=04a1fd48&prod&scoped=true&lang=css"
import style2 from "./Layout.vue?vue&type=style&index=2&id=04a1fd48&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a1fd48",
  null
  
)

export default component.exports